import { ModelRow, StringUtil } from "@mcleod/core";
import { AutogenLayoutFreightGroupItemCompareChangeItem } from "./autogen/AutogenLayoutFreightGroupItemCompareChangeItem";
import { DataSourceMode, TableRowDisplayEvent, Label, DataDisplayEvent } from "@mcleod/components";
import { BaseCompare } from "./BaseCompare";

export class FreightGroupItemCompareChangeItem extends AutogenLayoutFreightGroupItemCompareChangeItem {
    private _compareItems: ModelRow[];
    private _isCompareHistory: boolean = false;
    private _isOrderUpdateAllowed: boolean = true;
    private baseCompare = new BaseCompare();


    public get isOrderUpdateAllowed(): boolean {
        return this._isOrderUpdateAllowed;
    }

    public set isOrderUpdateAllowed(value: boolean) {
        this._isOrderUpdateAllowed = value;
    }

    public async setupTableData(data: ModelRow[]) {
        this._compareItems = data;
    }

    override onLoad(): void | Promise<void> {
        this.tableFreightGroupItemChangeItems.dataSource = this.sourceEdiCompareItem;
        this.tableFreightGroupItemChangeItems.dataSource.data = [];
        if (this._compareItems != null) {
            if (this._compareItems.length === 0) {
                this.tableFreightGroupItemChangeItems.visible = false;
            } else {
                this.tableFreightGroupItemChangeItems.dataSource.setRowsAndMode(DataSourceMode.NONE, this._compareItems);
            }
        }
    }

    onItemRowDisplay(event: TableRowDisplayEvent) {
        this.baseCompare.isOrderUpdateAllowed = this.isOrderUpdateAllowed;
        this.baseCompare.isCompareHistory = this.isCompareHistory;
        this.baseCompare.setupCheckboxBehavior(event.getTableRow(), this.isOrderUpdateAllowed, false);
    }



    valueOnDisplay(event: DataDisplayEvent) {
        const label = event.target as Label;
        if (label.text == "1900-01-01") {
            label.text = "";
        }
    }

    onDescrDisplay(event: DataDisplayEvent) {
        const labelDescr = <Label>event.target
        if (StringUtil.isEmptyString(event.rowData.get("target_descr"))) {
            labelDescr.text = event.rowData.get("source_descr");
        }
    }

    public get isCompareHistory(): boolean {
        return this._isCompareHistory;
    }

    public set isCompareHistory(isCompareHistory: boolean) {
        this._isCompareHistory = isCompareHistory;
    }
}
